<template>
  <div>
    <Navbar/>
    <div class="container">
      <div class="img">
        <img src="@/assets/images/pages/credit_card.svg">
      </div>
      <div class="card-container">
        <div class="form">
          <Logo class="logo text-primary fill-current" />
          <h3 class="mb-4">Payment Card Verification</h3>
          <p class="mb-4">This card verification just to preventing the potential fraud cases.</p>
          <p class="mb-4">Please note that we will <strong>not perform any charging</strong> to your card until your trial ends.</p>
          <vs-input 
            id="name"
            placeholder="Card Holder Name"
            v-model="name"
            name="Name"
            v-validate="'required|alpha_spaces'"
            class="w-full mt-6"/>
          <span class="text-danger text-sm" >{{ errors.first('Name') }}</span>
          <div class="mt-5" @change="complete = this.$event.complete" ref="card"></div>

          <vs-button v-show="!is_successful" class="w-full mt-6" ref="loadingbutton" @click.prevent="verifyCard">Add Card</vs-button>
          <vs-button v-show="is_successful" class="w-full mt-6" ref="loadingbutton">Continue</vs-button>
          <span :class="is_successful ? 'text-success text-sm mt-3 vx-col' : 'text-danger text-sm mt-3 vx-col'">{{ message }}</span>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue'
import Navbar from '@/views/components/quicksend-navbar/Navbar.vue'
import { CardNumber, CardExpiry, CardCvc } from 'vue-stripe-elements-plus'


let stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY),
    elements = stripe.elements(),
    card = undefined;

let style = {
    base: {
      iconColor: '#F9278E',
      color: '#F9278E',
      fontWeight: 500,
      fontFamily: 'inherit',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#fce883',
      },
      '::placeholder': {
        color: '#CFD7DF',
      },
    }
}


export default {
  data () {
    return {
      name:'',
      showCreditCard: false,
      popupCreditCard: false,
      message: '',
      is_successful: false,
    }
  },
  mounted() {
    card = elements.create('card',{style, hidePostalCode: true})
    card.mount(this.$refs.card)
  },
  created () {
    let payload = {
      email: this.$store.state.user.email,
      user_id: this.$store.state.user.id,
      organization_id: this.$store.state.user.current_organization,
    }
    this.$store.dispatch('card/getSetupIntent', payload)
  },
  components: {
    Logo,
    Navbar
  },
  computed: {
  },
  methods: {
    verifyCard() {
      this.$vs.loading()
      stripe.confirmCardSetup(
        this.$store.state.card.setupIntent, {
          payment_method: {
            card,
            billing_details: {
              name: this.name,
              email: this.$store.state.user.email
            },
          },
        }) 
        .then((res)=> {
          if(res.error) {
            this.$vs.loading.close()
            this.message = res.error.message
          } else {
            let callback_payload = {
              email: this.$store.state.user.email,
              user_id: this.$store.state.user.id,
              organization_id: this.$store.state.user.current_organization,
            }
            this.$store.dispatch('card/insertPaymentCard', callback_payload)
              .then(() => {
                this.$vs.loading.close()
                card.update({ disabled: true })
                this.is_successful = true
                this.message = 'Add Card Successful.'

                let param = {
                  user_id: this.$store.state.user.id,
                  onboard_step: 6
                }

                this.$store.dispatch('user/updateOnboardStep', param).then(
                  (result) => {
                    this.$router.push({path: '/signup/package'})
                  }
                ).catch((error) => { 
                  throw(error)
                });
              })
              .catch((err) => {
                this.$vs.loading.close()
                this.message = err.message
              })
          }
        })
    },
    }
}
</script>

<style scoped>
* {
    margin: 0;
    box-sizing: border-box;
}

body {
  display:flex;
}

.container {
    width: 50vw;
    height: 50vw;
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-gap: 10rem;
    padding: 0 2rem;
}

.img{
    display: flex;
    justify-content: flex-end;
    align-items: center
}

.img img{
   width: 400px; 
}

.card-container {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 30px;
    margin-bottom: 30px;
}

.form{
    width:360px;
}

.logo {
    width: 150px;
    place-items: center;
}

.input-div{
    display: grid;
    margin: 25px 0;
    padding: 5px 0;
}


.input-div > div {
    position: relative;
    height: 45px;

}

.vs-input-number {
    height: 50px;
}

/* .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555555;
} */


a{
  display: block;
  text-align: right;
  text-decoration: none;
  color: #999999;
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
}

a:hover{
  color:#f9278e;
}

.label-placeholder {
    padding: 1rem !important;
    padding-left: .5rem !important;
    font-size: 0.7rem !important;
    font-weight: 400;
    color:rgba(0,0,0,.4);
}

@media screen and (max-width: 1050px) {
    .container{
        grid-gap: 5rem;
    }
}

@media screen and (max-width: 1000px) {
    .form{
        width: 290px;
    }

    .form h3{
        font-size: 1.2rem;
    }
    .img img{
        width: 400px;
    }
}

vs-input[label-placeholder]{
    text-transform:capitalize;
} 

vs-input[label-placeholder]:focus{
    float: left;
}

.credit-card-inputs.complete {
  border: 2px solid green;
}

@media screen and (max-width: 900px) {
    .img{
        display:none;
    }
    .container{
        grid-template-columns: 1fr;
    }
    .card-container{
        justify-content: center;
    }
}
</style>
